import React from 'react';
import ceoImg from '../../assets/img/Aboutus7/ceo.png';
import { ArrowUpRight } from 'lucide-react';

const Aboutus7 = () => {
    return (
        <section className="aboutus7-section">
            <div className="aboutus7-container">
                <div className="aboutus7-left">
                    <h2 className="title">CEO <span className="text-secondary">Message</span></h2>
                    <h3 className="subtitle">Our goal is to grow and advance with our clients.</h3>
                    <p className="desc">
                        We are grateful for the trust our clients place in us, and in return, 
                        CAD Drafting will continue to deliver the best Architectural Scan to BIM 
                        modeling and CAD services. We are here today because of your confidence 
                        and support. Our aim is to become a global leader that provides the 
                        best value to our customers.
                    </p>

                    <div className="ceo-info">
                        <h4 className="ceo-name">Chandresh Chudasama</h4>
                        <p className="ceo-title">Founder & CEO, Scan to BIM Service Company</p>
                    </div>

                    <a href="/contact" className="ceo-cta-btn">
                        Talk to a BIM Expert <ArrowUpRight size={20} />
                    </a>
                </div>

                <div className="aboutus7-right">
                    <img src={ceoImg.src || ceoImg} alt="Chandresh Chudasama - CEO" className="ceo-main-img" />
                </div>
            </div>
        </section>
    );
};

export default Aboutus7;
